import { useCollectorPermission } from '../hooks/use-collector-permission'

import type { CollectorPermission } from '../permissions'
import type { PropsWithChildren } from 'react'

type CollectorPermissionGateProps = PropsWithChildren<{
	permission: CollectorPermission
	fallback?: React.ReactNode
}>

/**
 * Renders children only if the active role carries `permission` on an
 * active SKU.
 *
 * For the collector actions Analyst may take (run diagnostics, run
 * capture), which a role-rank gate (`HasActiveSystemManager`) cannot
 * express: it would hide them from Analyst or grant Analyst every write.
 * `permission` is per-action rather than one blanket check so a role
 * holding one collector permission and not another — diagnostics without
 * capture, say — is gated correctly without a frontend change.
 */
export const CollectorPermissionGate = ({
	permission,
	children,
	fallback,
}: CollectorPermissionGateProps) => {
	const hasPermission = useCollectorPermission(permission)

	if (hasPermission) {
		return <>{children}</>
	}

	return fallback ?? null
}
